import React from "react";
import styles from "../../../../assets/styles/components/Suggestion.module.scss";

// -----------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------
export type CampaignStatusSuggestion = {
    campaign_id: string;
    campaign_name: string;
    before_status: "ACTIVE" | "PAUSED";
    suggested_status: "ACTIVE" | "PAUSED";
    reason?: string;
};

type Props = {
    campaigns: CampaignStatusSuggestion[];
    formData: Record<string, "ACTIVE" | "PAUSED">;
    onChange: (id: string, status: "ACTIVE" | "PAUSED") => void;
};

// -----------------------------------------------------------------------------
// Component: CampaignStatusForm
// -----------------------------------------------------------------------------
const CampaignStatusForm: React.FC<Props> = ({ campaigns, formData, onChange }) => {
    const toLabel = (status: "ACTIVE" | "PAUSED") => (status === "ACTIVE" ? "配信中" : "一時停止");

    return (
        <div className={styles.campaignStatusFormContainer}>
            {campaigns.map((cp) => {
                const suggestedStatus = cp.suggested_status ?? cp.before_status;
                const currentStatus = formData[cp.campaign_id] ?? suggestedStatus;
                const isPaused = currentStatus === "PAUSED";

                return (
                    <section key={cp.campaign_id} className={styles.campaignCard}>
                        <div className={styles.campaignName}>{cp.campaign_name}</div>

                        {cp.reason && (
                            <div className={styles.reasonBar}>
                                <strong>Aibex提案理由:</strong> {cp.reason}
                            </div>
                        )}

                        <div className={styles.suggestionBox}>
                            {/* Before */}
                            <div className={styles.beforePanel}>
                                <div className={styles.panelTitle}>現在の設定</div>
                                <div className={styles.displayRow}>
                                    <div className={`${styles.statusBadge} ${cp.before_status === "ACTIVE" ? styles.bgOn : styles.bgOff}`}>
                                        {toLabel(cp.before_status)}
                                    </div>
                                </div>
                            </div>

                            {/* Arrow */}
                            <div className={styles.arrowIcon}>→</div>

                            {/* After */}
                            <div className={styles.afterPanel}>
                                <div className={styles.panelTitle}>AI提案</div>
                                <div className={styles.inputRow}>
                                    <label className={styles.checkboxSwitch}>
                                        <input
                                            type="checkbox"
                                            checked={isPaused}
                                            onChange={(e) => onChange(cp.campaign_id, e.target.checked ? "PAUSED" : "ACTIVE")}
                                        />
                                        <span className={styles.slider}></span>
                                    </label>
                                    <div className={`${styles.statusBadge} ${isPaused ? styles.bgOff : styles.bgOn}`}>
                                        {toLabel(currentStatus)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                );
            })}
        </div>
    );
};

export default CampaignStatusForm;
